module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-italic.3ac737a8.woff2";